import React, { Component } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'


import BoxSection from '../Layout/BoxSection'
import ModalConfirmarAccion from '../Shared/ModalConfirmarAccion'

import {
    updateInputs,
} from '../../actions/documentos'



class Cancelacion extends Component {

	render() {

        const { documento } = this.props 

        // let enableBtn = true 
        // enableBtn = enableBtn && moment().isAfter(`${new Date().getFullYear()}-02-03`) 
        // enableBtn = enableBtn && documento.get('estado') >= 12


        let enableBtn = true 
        enableBtn = enableBtn && moment().isAfter(`${new Date().getFullYear()}-11-30`) 
        enableBtn = enableBtn && documento.get('estado') >= 12



		return (
            <div>
                { (documento.get('tipo') == 5) && <div className="row">
                    <div className="col-md-2">
                        <div className="form-group">
                            <label htmlFor="fecha_rechazo" className="control-label" >Fecha de cierre</label>
                            <input type="date" className="form-control input-sm" name="fecha_rechazo" id="fecha_rechazo" value={moment(documento.get('fecha_cancelacion')).format('YYYY-MM-DD') || '' } disabled />
                        </div>
                    </div>
                </div> 
                }


                { (documento.get('tipo') == 5 && !documento.get('motivo_no_renovacion')) || documento.get('tipo') != 5 ?



                    <BoxSection title="Motivo de cancelación">

                        <div className="row">
                            <div className="col-md-2">
                                <div className="form-group">
                                    <label htmlFor="fecha_rechazo" className="control-label" >Fecha de cancelación</label>
                                    <input className="form-control input-sm" name="fecha_rechazo" id="fecha_rechazo" value={ documento.get('estado') == 0 ? moment(documento.get('fecha_cancelacion')).format('DD/MM/YYYY') : moment().format('DD/MM/YYYY') } disabled />
                                </div>
                            </div>
                        </div> 


                        <div className="row">
                            <div className="col-md-12">
                                <div className="form-group">
                                    <textarea type="text" className="form-control input-sm" rows={4} value={ documento.get('motivo_cancelacion') || '' } onChange={ (e) => this.props.updateInputs('modalSummary.data.motivo_cancelacion', e.target.value) } disabled = { documento.get('estado') == 0 } />
                                </div>
                            </div>
                        </div> 

                    </BoxSection>





                : null}


                {
                    (documento.get('tipo') == 5) && enableBtn && (

                        <BoxSection title="Motivo de no renovación">

                            <div className="row">
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <textarea type="text" className="form-control input-sm" rows={4} value={ documento.get('motivo_no_renovacion') || '' } onChange={ (e) => this.props.updateInputs('modalSummary.data.motivo_no_renovacion', e.target.value) } disabled = { documento.get('estado') == 14 } />
                                    </div>
                                </div>
                            </div> 

                        </BoxSection>

                    )
                }
                
                <ModalConfirmarAccion />

            </div>
		)
	}
}

function mapStateToProps(state) {
    return {
        documento: state.documentos.getIn(['modalSummary', 'data']),
    }
}


function mapDispatchToProps(dispatch) {
    return {
        updateInputs: (path, value) => dispatch(updateInputs(path, value)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Cancelacion)


// WEBPACK FOOTER //
// ./src/components/Documentos/Cancelacion.jsx